const FIC_STATUS = "FIC";
const BIC_STATUS = "BIC";
const FIC_BIC_STATUS = "FIC_BIC";
const NONE_STATUS = "NONE";

export default {
    checkHasFicBicStatus(self, brandId){
        const brandFicBicData = self.ficBicData[brandId];
        let search = brandFicBicData ? [...Object.values(brandFicBicData.classes)] : [];

        if(brandFicBicData.group_revenue){
            Object.values(self.ficBicData)
                .filter((e)=> e.drug_id == brandFicBicData.drug_id && e.id != brandFicBicData.id &&e.group_revenue)
                .forEach((e)=>search.push(...Object.values(e.classes)));
        }

        const fic_class = search
            .find((e)=> e.fic_from != null);

        const bic_class =  search
            .find((e)=> e.bic_from != null); 

        return fic_class != undefined || bic_class!= undefined;
    },

    getSplitPoint(self, d, eventDateData) {
        const dataKey = Object.keys(self.data).find((key)=> Object.values(self.data[key]).find((e)=>e.id == d.id) !== undefined);
        if (dataKey === undefined) return;

        const eventDate = new Date(eventDateData);

        var quarter = Math.floor(eventDate.getMonth() / 3);
        var firstDate = new Date(eventDate.getFullYear(), quarter * 3, 1);
        var endDate = new Date(firstDate.getFullYear(), firstDate.getMonth() + 3, 0);

        const days = new Date(endDate - firstDate) / 1000 / 60 / 60 / 24;
        const eventDateDIff = new Date(eventDate - firstDate) / 1000 / 60 / 60 / 24;
        const datePercentage = (eventDateDIff * 100) / days;

        let currentQuarter = Math.ceil((eventDate.getMonth() + 1) / 3);
        let yearToGet =
            currentQuarter === 4 ? eventDate.getFullYear() + 1 : eventDate.getFullYear();
        let quarterToGet = currentQuarter === 4 ? 1 : currentQuarter + 1;
        let nextRevItem = self.filters.startSyncView
            ? self.data[dataKey][d.indexedQuarter + 1]
            : self.data[dataKey].find(
                  a => a.year === yearToGet && a.quarter === "Q" + quarterToGet.toString()
              );
        let revenue = nextRevItem ? nextRevItem.revenue : d.revenue;
        let revDiff = revenue - d.revenue;

        const ploatY = (datePercentage / 100) * revDiff;

        return {
            xFactor: datePercentage / 100,
            yFactor: ploatY
        };
    },

    drawData(self, data, dataKey, line, lineColor, userFicBicColors) {
        data[dataKey].forEach((revenues) => {
            const firstRevState = this.getFicBicStatus(
                    self,
                    revenues[0].drug_brand_name,
                    this.getQuarterStartDate(revenues[0].quarter, revenues[0].year)
                );

            if (revenues.length === 1) {
                const circleColor = this.getStateColor(firstRevState, lineColor, userFicBicColors);

                line.append("circle")
                    .datum(revenues[0])
                    .attr("class", "data-circle select")
                    .attr("r", 8)
                    .attr("fill", circleColor);

                line.append("circle")
                    .datum(revenues[0])
                    .attr("class", "data-circle main")
                    .attr("r", firstRevState != NONE_STATUS ? 4 : 2)
                    .attr("fill", circleColor);
            }

            let pathData = [];
            let pathStatus = firstRevState;

            revenues.forEach((element, index) => {
                const nextPathStatus = this.getFicBicStatus(
                    self,
                    element.drug_brand_name,
                    this.getQuarterEndDate(element.quarter, element.year)
                );
                let splitPoint = null;
                if (pathStatus != nextPathStatus || index == revenues.length - 1) {
                    if (index == revenues.length - 1) {
                        pathData.push(element);
                    }

                    const pathLineColor = this.getStateColor(pathStatus, lineColor, userFicBicColors);

                    const newPathData = [];

                    if (index < revenues.length - 1) {
                        let eventDate = null;

                        eventDate = this.getStatusChangeDate(self, pathStatus, nextPathStatus, element.drug_brand_id );
                        splitPoint = {
                            ...element,
                            ...this.getSplitPoint(self, element, eventDate),
                            isGenerated: true
                        };
                        pathData.push(element, splitPoint);
                        newPathData.push(splitPoint);
                    }

                    // create a path
                    line.append("path")
                        .attr("class", "data-line select")
                        .attr("stroke", pathLineColor)
                        .datum(pathData);

                    line.append("path")
                        .attr("class", "data-line shadow")
                        .attr("stroke", pathLineColor)
                        .datum(pathData);

                    line.append("path")
                        .attr("class", "data-line main")
                        .attr("stroke", pathLineColor)
                        .attr("stroke-width", pathStatus !== NONE_STATUS ? 4 : 2)
                        .datum(pathData);

                    pathStatus = nextPathStatus;
                    pathData = newPathData;
                }
                if(splitPoint == null){
                    pathData.push(element);
                }
            });
        });
    },

    getStateColor(state, lineColor, userFicBicColors) {
        const { fic_color, bic_color, fic_bic_color } = userFicBicColors;
        switch (state) {
            case FIC_BIC_STATUS:
                return fic_bic_color;

            case FIC_STATUS:
                return fic_color;

            case BIC_STATUS:
                return bic_color;

            case NONE_STATUS:
                return lineColor;

            default:
                throw new Error(`${state} is not supported`);
        }
    },

    getQuarterStartDate(quarter, year) {
        let month = 0;
        switch (quarter.substring(1)) {
            case "1":
                month = 0;
                break;
            case "2":
                month = 3;
                break;
            case "3":
                month = 6;
                break;
            case "4":
                month = 9;
                break;
        }
        return new Date(year * 1, month, 1);
    },
    getQuarterEndDate(quarter, year) {
        let month = 1;
        switch (quarter.substring(1)) {
            case "1":
                month = 3;
                break;
            case "2":
                month = 6;
                break;
            case "3":
                month = 9;
                break;
            case "4":
                month = 12;
                break;
        }
        return new Date(year * 1, month, 0);
    },

    __getBrandFicBicState(self, id, date) {
        const brandFicBicData = self.ficBicData[id];

        const revDate = new Date(date);

        const states = Object.values(brandFicBicData.classes).map((classData)=>{
            const fic_from_date =
                classData.fic_from != null ? new Date(classData.fic_from) : null;
            const fic_to_date =
                classData.fic_to != null ? new Date(classData.fic_to) : null;

            const bic_from_date =
                classData.bic_from != null ? new Date(classData.bic_from) : null;
            const bic_to_date =
                classData.bic_to != null ? new Date(classData.bic_to) : null;

            const fic_bic_from_date =
                classData.fic_from && classData.bic_from ? new Date(Math.max(new Date(classData.fic_from), new Date(classData.bic_from))) : null;

            let fic_bic_to_date = null;
            if(fic_bic_from_date){
                if( classData.fic_to && classData.bic_to)
                    fic_bic_to_date =  new Date(Math.min(new Date(classData.fic_to), new Date(classData.bic_to)));
                else if(classData.fic_to)
                    fic_bic_to_date = new Date(classData.fic_to)
                else if(classData.bic_to)
                    fic_bic_to_date = new Date(classData.bic_to);
            }

            const is_fic_bic =
                classData.fic_from != null &&
                classData.bic_from != null &&
                fic_bic_from_date < revDate &&
                (fic_bic_to_date == null || revDate < fic_bic_to_date);

            const is_fic =
                classData.fic_from != null &&
                fic_from_date < revDate &&
                (fic_to_date == null || revDate < fic_to_date);

            const is_bic =
                classData.bic_from != null &&
                bic_from_date < revDate &&
                (bic_to_date == null || revDate < bic_to_date);

            if (is_fic_bic) {
                return FIC_BIC_STATUS;
            }
    
            if (is_fic) {
                return FIC_STATUS;
            }
    
            if (is_bic) {
                return BIC_STATUS;
            }
    
            return NONE_STATUS;
        });

        if(states.find((e)=>e == FIC_BIC_STATUS)) return FIC_BIC_STATUS;
        else if(states.find((e)=>e == FIC_STATUS) && states.find((e)=>e == BIC_STATUS))
            return FIC_BIC_STATUS;
        else if(states.find((e)=>e == FIC_STATUS)) return FIC_STATUS;
        else if(states.find((e)=>e == BIC_STATUS)) return BIC_STATUS;
        return NONE_STATUS;
    },

    getFicBicStatus(self, drug_brand_name, date ) {
        let brandFicBicData = [self.ficBicData[drug_brand_name.id]];

        if (drug_brand_name.group_revenue) {
            brandFicBicData = Object.values(self.ficBicData)
                .filter(e => e.drug_id == drug_brand_name.drug_id && e.group_revenue == 1)
                .map(e => self.ficBicData[e.id]);
        }

        const results = brandFicBicData.map(e =>
            this.__getBrandFicBicState(self, e.id, date)
        );

        if(results.find((e)=>e == FIC_BIC_STATUS)) return FIC_BIC_STATUS;
        else if(results.find((e)=>e == FIC_STATUS) && results.find((e)=>e == BIC_STATUS))
            return FIC_BIC_STATUS;
        else if(results.find((e)=>e == FIC_STATUS)) return FIC_STATUS;
        else if(results.find((e)=>e == BIC_STATUS)) return BIC_STATUS;
        return NONE_STATUS;
    },

    getStatusChangeDate(self, pervStatus, currStatus, drug_brand_id) {

        let brandsData = [self.ficBicData[drug_brand_id]];
        if(self.ficBicData[drug_brand_id].group_revenue){
            brandsData = Object.values(self.ficBicData)
                .filter((e)=>e.drug_id == self.ficBicData[drug_brand_id].drug_id && e.group_revenue == 1); 
        }
        const res = brandsData.map((e)=>{
            return Object.values(e.classes).map((classData)=>{
                if (pervStatus == FIC_BIC_STATUS) {
                    if(currStatus == NONE_STATUS){
                        if(classData.fic_to && classData.bic_to){
                            return (new Date(Math.min(new Date(classData.fic_to), new Date(classData.bic_to))))
                                .toISOString().slice(0, 10);
                        }else if(classData.fic_to){
                            return classData.fic_to;
                        }else{
                            return classData.bic_to;
                        }
                    }
    
                    return currStatus == FIC_STATUS
                        ? classData.bic_to
                        : classData.fic_to;
                }
        
                if (pervStatus == FIC_STATUS) {
                    return currStatus == FIC_BIC_STATUS || currStatus == BIC_STATUS
                        ? classData.bic_from
                        : classData.fic_to;
                }
    
                if (pervStatus == BIC_STATUS) {
                    return currStatus == NONE_STATUS 
                        ? classData.bic_to
                        : classData.fic_from;
                }
    
                if (pervStatus == NONE_STATUS) {
                    if(currStatus == FIC_BIC_STATUS){
                        if(classData.fic_from && classData.bic_from){
                            return (new Date(Math.max(new Date(classData.fic_from), new Date(classData.bic_from))))
                                .toISOString().slice(0, 10);
                        }else if(classData.fic_from){
                            return classData.fic_from;
                        }else{
                            return classData.bic_from;
                        }
                    }

                    return currStatus == BIC_STATUS
                        ? classData.bic_from
                        : classData.fic_from;
                }
    
                return null;
            }).filter((e)=>e!= null);
        }).flat()

        if (res.length == 0){
            throw new Error("non handled case has ocuuerd");
        }
    
        return res[0];
    }
};
